import {outter_post} from 'common/js/axios-helper';
import {SystemPropApi} from "./constant/UrlMapper";

const host = "8885"


const add = (data) => {
    return outter_post(SystemPropApi.Add, data, host);
};
const list = (data) => {
    return outter_post(SystemPropApi.List, data, host);
};
const detail = (data) => {
    return outter_post(SystemPropApi.Detail, data, host);
};

const update = (data) => {
    return outter_post(SystemPropApi.Update, data, host);
};

const exist = (data) => {
    return outter_post(SystemPropApi.Exist, data, host);
};

const meltList = (data) => {
    return outter_post(SystemPropApi.meltList, data, host);
};

const meltEdit = (data) => {
    return outter_post(SystemPropApi.meltEdit, data, host);
};


export default {add, list, detail, update,exist, meltList, meltEdit}



// WEBPACK FOOTER //
// ./src/service/SystemPropertiesService.js